var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38.176,
    height: 38.177,
    viewBox: "0 0 38.176 38.177",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 38.176,
    height: 38.177,
    fill: "#2e90d8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_824",
    "data-name": "Group 824",
    transform: "translate(-1343 -8065.594)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(1343 8065.594)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34312",
    "data-name": "Path 34312",
    d: "M20.2,0c.736.1,1.479.161,2.208.3a18.8,18.8,0,0,1,13.52,9.836,17.7,17.7,0,0,1,2.209,9.753,18.712,18.712,0,0,1-10.1,16.035,17.485,17.485,0,0,1-9.751,2.215,18.742,18.742,0,0,1-16.041-10.1A17.665,17.665,0,0,1,.063,20.526,2.534,2.534,0,0,0,0,20.2V17.967a2.532,2.532,0,0,0,.063-.321,17.955,17.955,0,0,1,2.178-7.517A18.832,18.832,0,0,1,15.761.3c.728-.14,1.471-.2,2.207-.3ZM19.065,36.441A17.355,17.355,0,1,0,1.731,19.065,17.377,17.377,0,0,0,19.065,36.441",
    fill: "#2e90d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34313",
    "data-name": "Path 34313",
    d: "M172.674,136.082h-3.462V128.3h-1.719v-2.609h1.717c0-.179-.007-.335,0-.49a24.732,24.732,0,0,1,.162-2.48,2.422,2.422,0,0,1,1.8-1.984,13.556,13.556,0,0,1,4.077-.21c.007.079.02.163.02.248,0,.755,0,1.51,0,2.317h-.87c-.186,0-.373,0-.559,0-.974.024-1.164.217-1.173,1.2,0,.445,0,.891,0,1.385h2.609l-.3,2.612h-2.307Z",
    transform: "translate(-151.853 -109.204)",
    fill: "#2e90d8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.dbfd0044e5cff76ce2c3d9bee2fd6213.svg";
export { ForwardRef as ReactComponent };